'use client'

import { useId } from 'react'

import { useTranslation } from '@/hooks/client/use-translation'
import { tw } from '@/lib/utils'

import { SORT_OPTIONS } from '../sort-control'
import type { SortOption } from '../use-directory-reducer'

interface SortPillsProps {
  value: SortOption
  onChange: (sort: SortOption) => void
}

// The sort options inside the phone filter sheet: one pill row, exactly one
// active (sorting always applies, so unlike the facets it cannot be cleared).
export const SortPills = ({ value, onChange }: SortPillsProps) => {
  const { t } = useTranslation()
  const headingId = useId()
  return (
    <div role="group" aria-labelledby={headingId} className="border-navy/10 border-b py-3">
      <p id={headingId} className="text-navy mb-3 text-[15px] font-semibold">
        {t('directory.sort.label', 'Sort')}
      </p>
      <div className="flex flex-wrap gap-2 pb-1">
        {SORT_OPTIONS.map((option) => {
          const active = option.value === value
          return (
            <button
              key={option.value}
              type="button"
              data-tracking="ignore"
              aria-pressed={active}
              onClick={() => onChange(option.value)}
              className={tw(
                'focus-visible:outline-lapis inline-flex min-h-[40px] cursor-pointer items-center rounded-full border px-3.5 text-[14px] font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2',
                active ? 'border-navy bg-navy text-white' : 'border-navy/20 text-navy hover:border-navy bg-white'
              )}
            >
              {t(option.key, option.fallback)}
            </button>
          )
        })}
      </div>
    </div>
  )
}
